import { render, staticRenderFns } from "./modalInfoPago.vue?vue&type=template&id=b1986068&scoped=true"
import script from "./modalInfoPago.vue?vue&type=script&lang=js"
export * from "./modalInfoPago.vue?vue&type=script&lang=js"
import style0 from "./modalInfoPago.vue?vue&type=style&index=0&id=b1986068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1986068",
  null
  
)

export default component.exports